export const JOB_TYPE_INS = 1
export const JOB_TYPE_PVT = 0
export const JOB_TYPE_OTC = 2
export const JOB_TYPE_CASH = 3
export const JOB_TYPE_NONE = null

export const JOB_TYPES = [
  JOB_TYPE_INS,
  JOB_TYPE_PVT,
  JOB_TYPE_OTC,
  JOB_TYPE_CASH,
]
